import { InputSuffix, TextBox } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faFilterCircleXmark } from '@fortawesome/free-solid-svg-icons';
import type { TextBoxFilterProps } from './textbox-filter.types.ts';
import styles from './textbox-filter.module.scss';

export function TextBoxFilter({ value, onChange, onClear, style, placeholder }: TextBoxFilterProps) {
  return (
    <TextBox
      type={'text'}
      name={'filter'}
      value={value}
      className={styles.filter}
      placeholder={placeholder}
      style={style}
      suffix={() => (
        <>
          {value ? (
            <InputSuffix orientation={'horizontal'}>
              <Button title={'Clear filter'} themeColor={'primary'} onClick={onClear}>
                <FontAwesomeIcon icon={faFilterCircleXmark} />
              </Button>
            </InputSuffix>
          ) : (
            <InputSuffix orientation={'horizontal'}>
              <Button disabled={true}>
                <FontAwesomeIcon icon={faFilter} />
              </Button>
            </InputSuffix>
          )}
        </>
      )}
      onChange={onChange}
    />
  );
}
